module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/people-3714e33e6d2d674ee4828c4aae69408c.svg&quot;;"